import { api, LocalStorageKey, p2BackendApiInstance } from '../api';
import {
  ChangeNamesParams,
  GetUserPreRegistrationIdsParams,
  GetUserPreRegistrationIdsResponse,
  LoginLandingRequest,
  LoginRequest,
  LoginResponse,
  PreRegisterUser,
  RefreshParams
} from './auth.types';
import { authUrls } from './auth.urls';

export class AuthApiService {
  public static async login(params: LoginRequest): Promise<LoginResponse> {
    const { data } = await api.post(authUrls.login, params);

    return data;
  }

  public static async loginLanding(params: LoginLandingRequest): Promise<LoginResponse> {
    const { data } = await api.post(authUrls.loginLanding, params);

    return data;
  }

  public static async register(): Promise<boolean> {
    const { data } = await api.post(authUrls.register);

    return data;
  }

  public static async getAuthMessageToSign(address: string): Promise<string> {
    const {
      data: { message }
    } = await api.get(authUrls.message, { params: { address: address } });

    return message;
  }

  public static async getUser(): Promise<any> {
    const { data } = await api.get(authUrls.user);

    return data;
  }

  public static async refreshToken(params?: RefreshParams): Promise<LoginResponse> {
    const { data } = await api.post(authUrls.refresh, {
      ...(params || {}),
      refreshToken: localStorage.getItem(LocalStorageKey.refresh)
    });

    return data;
  }

  public static async isUserRegistered(userId: number): Promise<boolean> {
    const { data } = await p2BackendApiInstance.get(authUrls.isRegistered(userId));

    return data;
  }
  public static async preRegisterUser(preRegisterUser: PreRegisterUser): Promise<boolean> {
    const { data } = await p2BackendApiInstance.post(authUrls.preregister, preRegisterUser);

    return data;
  }

  public static async getUserPreRegistrationIds(
    params: GetUserPreRegistrationIdsParams
  ): Promise<GetUserPreRegistrationIdsResponse> {
    const { data } = await p2BackendApiInstance.get(authUrls.preRegistrationIds, { params });

    return data;
  }

  public static async changeNames(names: ChangeNamesParams): Promise<boolean> {
    const { data } = await api.post(authUrls.changeNames, names);

    return data;
  }
}
